module.exports = __webpack_public_path__ + "img/invoice-card-icon.2dd5fba3.svg";